import { throttle } from 'lodash-es';

import logger from '../../services/logging/logging-service';
import { isInjectedHPInView } from '../../utils/injected-hp-utils';
import { isLargeScreen, isNotLargeScreen, isLandscape, isPortrait } from '../../utils/mediaquery-utils';

const SCROLL_EVENT_TROTTLE_TIME = 200;

const STICKY_STATE = 'sticky';
const IS_VISIBLE = 'isVisible';
const IS_HIDDEN = 'isHidden';
const IS_HIDDEN_MOBILE = 'isHiddenMStickyD';
const DATA_STATE_PRIMARY_TAG = 'hasPrimaryTag';
const DATA_STATE_SECTION_NAV = 'hasSectionNav';

const $globalNav = document.querySelector('.j-global-nav');
const $localNav = document.querySelector('.j-local-nav');
const $localMenuTitle = document.querySelector('.j-local-title'); // Inside local nav
const $localFeatured = document.querySelector('.j-local-nav__featured'); // Inside local nav
const $sectionNav = document.querySelector('.j-section-nav-wrapper');
const $sectionNavSubElements = $sectionNav?.querySelectorAll('.j-list-nav');
const $primaryTag = document.querySelector('.j-primary-tag');
const $advList = document.querySelectorAll('.u-sticky');
const navStatePrimary = $primaryTag ? DATA_STATE_PRIMARY_TAG : null;
const navStateSection = $sectionNav ? DATA_STATE_SECTION_NAV : null;

const $navController = $primaryTag || $sectionNav;
const navState = navStatePrimary || navStateSection;

const options = {
  rootMargin: '0px',
  threshold: 0,
};

let isGlobalNavInView = false;
let scrollPos = 1000;

if (isLargeScreen()) {
  $navController.setAttribute('data-state', IS_HIDDEN_MOBILE);
  $localNav.setAttribute('data-state', IS_VISIBLE);
}

const globalNavObserverCallback = (globalNavEntries) => {
  globalNavEntries.forEach((globalNavEntry) => {
    // When the Global Nav is intersecting --> Local Nav IS NOT sticky
    // And vice-versa
    const globalNavIsIntersecting = globalNavEntry.isIntersecting && !isGlobalNavInView;
    const globalNavIsNotIntersecting = !globalNavEntry.isIntersecting && isGlobalNavInView;
    if (isLargeScreen()) {
      $navController.setAttribute('data-state', IS_HIDDEN_MOBILE);
      $localNav.setAttribute('data-state', IS_VISIBLE);
    }

    if (isNotLargeScreen() && globalNavIsIntersecting) { // Local Nav is NOT sticky
      $navController.setAttribute('data-state', IS_HIDDEN_MOBILE);
      $localNav.setAttribute('data-state', IS_VISIBLE);
      isGlobalNavInView = true;
    }

    if (isNotLargeScreen() && globalNavIsNotIntersecting) { // Local Nav is sticky
      isGlobalNavInView = false;
    }
  });
};

const handleScrollingOnMobile = () => {
  const topPos = (document.body.getBoundingClientRect()).top;
  const isScrollingUp = topPos > scrollPos;
  const isScrollingDown = topPos <= scrollPos;
  if (!isGlobalNavInView) {
    if (!isInjectedHPInView() && isScrollingUp) {
      $navController.setAttribute('data-state', STICKY_STATE);
      $localNav.setAttribute('data-state', IS_HIDDEN);
    }
    if (!isInjectedHPInView() && isScrollingDown) {
      $navController.setAttribute('data-state', IS_HIDDEN_MOBILE);
      $localNav.setAttribute('data-state', IS_VISIBLE);
    }
  }
  scrollPos = topPos;
};

const globalNavObserver = new IntersectionObserver(globalNavObserverCallback, options);

const showArticleLocalMenuTitle = () => {
  !$localMenuTitle.classList.contains('has-visibile') ? $localMenuTitle.classList.add('has-visibile') : null;
};

const hideArticleLocalMenuTitle = () => {
  $localMenuTitle.classList.contains('has-visibile') ? $localMenuTitle.classList.remove('has-visibile') : null;
};

const showLocalFeatured = () => {
  $localFeatured.classList.contains('has-scroll-visible') ? $localFeatured.classList.remove('has-scroll-visible') : null;
};

const hideLocalFeatured = () => {
  !$localFeatured.classList.contains('has-scroll-visible') ? $localFeatured.classList.add('has-scroll-visible') : null;
};

/**
 * Hide Primary Tag or section menu and show local navigation
 * [Current it is used in HP after Article: article --> HP]
 */
export const hidePrimaryShowLocalWithoutTitle = () => {
  if (isNotLargeScreen()) {
    globalNavObserver.unobserve($globalNav);
    $navController ? $navController.setAttribute('data-state', IS_HIDDEN_MOBILE) : null;
    $localNav.setAttribute('data-state', IS_VISIBLE);
    // hideArticleLocalMenuTitle();
  } else {
    $navController ? $navController.setAttribute('data-state', IS_HIDDEN) : null;
    hideArticleLocalMenuTitle();
    showLocalFeatured();
  }
};

/**
 * Show Primary Tag or section menu and hide local navigation
 * [Current it is used in HP after Article: HP --> article]
 */
export const showPrimaryHideLocal = () => {
  if (isLargeScreen()) {
    $navController ? $navController.setAttribute('data-state', IS_HIDDEN_MOBILE) : null;
    showArticleLocalMenuTitle();
    hideLocalFeatured();
  }
};

export const initPrimaryTag = () => {
  const sectionNavHasSubMenuOnMobile = isNotLargeScreen() && Boolean($sectionNavSubElements?.length);
  if ($globalNav && $navController && !sectionNavHasSubMenuOnMobile) {
    logger.info('Start initPrimaryTag...');
    $advList.forEach((advContainer) => {
      advContainer.setAttribute('data-state', navState);
    });

    // Control if it's in the middle of the page
    if ($globalNav.getBoundingClientRect().bottom < window.pageYOffset) {
      isGlobalNavInView = true;
    }

    globalNavObserver.observe($globalNav);

    let currentViewportWidth = window.innerWidth;
    let currentViewportHeight = window.innerHeight;
    window.addEventListener(
      'resize',
      throttle(() => {
        if (window.innerWidth !== currentViewportWidth || window.innerHeight !== currentViewportHeight) {
          logger.info('----- primary tag -- risized -----');
          if (isLandscape() && isLargeScreen()) {
            globalNavObserver.unobserve($globalNav);
            $localNav.setAttribute('data-state', IS_VISIBLE);
            if (!isInjectedHPInView()) {
              $navController.setAttribute('data-state', IS_HIDDEN_MOBILE);
            } else {
              $navController.setAttribute('data-state', IS_HIDDEN);
              showLocalFeatured();
            }
          }
          if (isPortrait() || (isLandscape() && isNotLargeScreen())) {
            globalNavObserver.unobserve($globalNav);
            if (!isInjectedHPInView()) {
              // not on top of the page
              if ($globalNav.getBoundingClientRect().bottom < window.pageYOffset) {
                $navController ? $navController.setAttribute('data-state', STICKY_STATE) : null;
                $navController
                  ? $localNav.setAttribute('data-state', IS_HIDDEN)
                  : $localNav.setAttribute('data-state', IS_VISIBLE);
                // showArticleLocalMenuTitle();
                logger.info('--- resize portrait - page middle articolo ---');
                globalNavObserver.observe($globalNav);
              } else {
                $navController.setAttribute('data-state', IS_HIDDEN_MOBILE);
                $localNav.setAttribute('data-state', IS_VISIBLE);
                globalNavObserver.observe($globalNav);
                logger.info('--- resize portrait - page top articolo ---');
              }
            } else {
              $navController ? $navController.setAttribute('data-state', IS_HIDDEN_MOBILE) : null;
              $localNav.setAttribute('data-state', IS_VISIBLE);
              hideArticleLocalMenuTitle();
              logger.info('--- resize portrait - page HP ---');
            }
          }
          currentViewportWidth = window.innerWidth;
          currentViewportHeight = window.innerHeight;
        }
      }, SCROLL_EVENT_TROTTLE_TIME)
    );

    if (isNotLargeScreen()) {
      window.addEventListener('scroll', throttle(handleScrollingOnMobile, SCROLL_EVENT_TROTTLE_TIME));
    }
  }
};
